import {textbausteinTypes1} from "../../components/Textbausteine/textbausteinTypes";

class TextbausteinSchema {
  constructor() {
    this.fields = {
      type: {
        name: "type",
        type: "string",
        fieldType: "select",
        label: "Typ",
        col: 6,
        required: true,
        sort: 2,
        options: [
          {key: "afb1Tb", value: textbausteinTypes1.afb1Tb.headline},
          {key: "afb2Tb", value: textbausteinTypes1.afb2Tb.headline},
          {key: "afb3Tb", value: textbausteinTypes1.afb3Tb.headline},
          {key: "spracheTb", value: textbausteinTypes1.spracheTb.headline},
          {key: "spracheKorrektTb", value: textbausteinTypes1.spracheKorrektTb.headline},
          {key: "spracheAusdruckTb", value: textbausteinTypes1.spracheAusdruckTb.headline},
          {key: "spracheLesenTb", value: textbausteinTypes1.spracheLesenTb.headline}
        ],
        validation: {
          maxLength: 30,
          minLength: 1
        },
        initialValue: "afb1Tb"
      },
      number: {
        name: "number",
        type: "string",
        fieldType: "select",
        label: "Nummer",
        col: 6,
        required: true,
        sort: 3,
        validation: {
          maxLength: 1,
          minLength: 1
        },
        options: [
          {key: "A", value: "A"},
          {key: "B", value: "B"},
          {key: "C", value: "C"},
          {key: "D", value: "D"},
          {key: "E", value: "E"}
        ],
        initialValue: "A"
      },
      text: {
        name: "text",
        type: "string",
        fieldType: "textarea",
        label: "Textbaustein",
        col: 12,
        required: true,
        sort: 3,
        validation: {
          minLength: 1
        }
      },
      punkte: {
        name: "punkte",
        type: "string",
        fieldType: "text",
        label: "Punkte",
        col: 3,
        required: true,
        sort: 4,
        validation: {
          maxLength: 20,
          minLength: 1
        },
        placeholder: "Geben Sie die Punkte kommagetrennt ein, z.B. 15, 14, 13"
      }
    };
  }
}

export default TextbausteinSchema;
